<template>
  <div class="">
    <div class="d-flex flex-row align-center justify-space-between mb-4">
      <div class="top-header mb-0">Seller Accounts</div>
    </div>

    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>

    <div class="d-flex flex-row align-center justify-space-between mb-5">
      <v-btn
        v-if="hasPermissions(createBtnPerms)"
        class="text-capitalize white--text"
        width="200"
        color="#0F52BC"
        tile
        depressed
        @click="goToCreate()"
      >
        <img class="mr-1" width="28px" height="28px" src="/icons/plus.svg" />
        {{ $t("CreateNewAccount") }}
      </v-btn>

      <div class="d-flex flex-row align-center">
        <v-text-field
          @keydown.enter="getAdmins()"
          v-model="qSearch"
          solo
          dense
          flat
          :label="$t('SearchAccounts') + '...'"
          style="max-width: 250px; border-radius: 8px"
          hide-details
        >
          <img
            slot="prepend-inner"
            width="20px"
            height="20px"
            src="/icons/search.svg"
          />
        </v-text-field>
        <v-btn
          depressed
          tile
          class="text-capitalize white--text ml-5"
          color="#0F52BC"
          @click="getAdmins()"
        >
          <img width="32px" height="32px" src="/icons/reload.svg" />
          {{ $t("Reload") }}</v-btn
        >
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="admins"
      :options.sync="options"
      :server-items-length="totalAdmins"
      :loading="loadingTable"
      :loading-text="`${$t('Loading')}... ${$t('PleaseWait')}`"
      :footer-props="footerProps"
    >
      <template v-slot:[`item.edit`]="{ item }">
        <v-btn
          icon
          small
          @click="goToAdmin(item)"
          :disabled="!hasPermissions(editPencilPerms)"
        >
          <img width="20px" height="20px" src="/icons/edit.svg" />
        </v-btn>
      </template>
      <template slot="header">
        <tr class="hidden-sm-and-down">
          <th>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" small @click="getAdmins()">
                  <img width="20px" height="20px" src="/icons/filter.svg" />
                </v-btn>
              </template>
              <span>filter admins</span>
            </v-tooltip>
          </th>
          <th>
            <v-text-field
              class="mt-5 admin-filter-input"
              dense
              outlined
              placeholder=" "
              label="Name"
              v-model="filterParams.name"
              @keydown.enter="getAdmins()"
            ></v-text-field>
          </th>
          <th>
            <v-text-field
              class="mt-5 admin-filter-input"
              dense
              outlined
              placeholder=" "
              label="Email"
              v-model="filterParams.email"
              @keydown.enter="getAdmins()"
            ></v-text-field>
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import RestResourceAdmin from "@/api/apiAdminService";
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { Permission } from "@/utils/permissions";
import { permissionMixin } from "@/utils/mixins";
import { vdataTable } from "@/plugins/vuetify-custom-props";
import RestResourceSeller from "../../api/apiSellerService";
export default {
  name: "AdminList",
  mixins: [permissionMixin],
  data() {
    return {
      loadingTable: false,
      admins: [],
      options: {},
      footerProps: {
        ...vdataTable.footerProps,
        prevIcon: "mdi-chevron-left orange--text text--darken-2",
        nextIcon: "mdi-chevron-right orange--text text--darken-2"
      },
      totalAdmins: 0,
      qSearch: "",
      errorAlert: false,
      errorMsg: "",
      filterParams: {
        name: null,
        email: null,
        phone: null,
        role: "Seller",
      },
      headers: [
        {
          text: this.$t("Edit"),
          align: "start",
          sortable: false,
          width: 100,
          value: "edit"
        },
        {
          text: this.$t("Name"),
          width: 225,
          align: "start",
          sortable: false,
          value: "fullName"
        },
        { text: "Email", value: "email", sortable: false },
        { text: "Register date", value: "createdAt", sortable: false }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.getAdmins();
      },
      deep: true
    }
  },
  computed: {
    editPencilPerms() {
      return [Permission.EDIT_ADMIN];
    },
    createBtnPerms() {
      return [Permission.ADD_ADMIN];
    }
  },
  methods: {
    getAdmins() {
      if (this.qSearch.length >= 1 && this.qSearch.length <= 2) {
        this.errorAlert = true;
        this.errorMsg = "The search must have 3 or more characters.";
        return;
      }
      this.loadingTable = true;
      RestResourceSeller.prototype
        .getSellers(this.getParams())
        .then(response => {
          if (response.status === ResponseStatus.OK) {
            this.totalAdmins = response.data.total;
            this.admins = response.data.data;
            console.log(this.admins);
            this.admins.map(admin => {
              admin.fullName = admin.name + " " + admin.lastName;
            });
            this.admins.forEach((admin, index) => {
              this.admins[index].createdAt = this.admins[index].createdAt
                .split("T")
                .join(" ")
                .split("-")
                .join("/")
                .split(".")[0];
            });
          }
        })
        .catch(error => {
          this.errorMsg = error.response.data.message;
          this.errorAlert = true;
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    goToCreate() {
      this.$router.push({ name: "new_seller_account" });
    },
    goToAdmin(admin) {
      this.$router.push({
        name: "sellerId",
        params: { id: admin._id }
      });
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      let params = {
        q: this.qSearch || null,
        skip: (page - 1) * itemsPerPage,
        limit: itemsPerPage
      };
      params = { ...params, ...this.filterParams };
      return params;
    }
  }
};
</script>

<style>
.admin-filter-input >>> .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  font-size: 1rem !important;
  font-weight: 200;
}
.admin-filter-input >>> .v-select__slot .v-input__append-inner {
  margin-top: 5px !important;
}
.admin-filter-input >>> .v-select__selections {
  font-size: 12px;
}
</style>
